module.exports = __webpack_public_path__ + "static/media/evsc.a132dcb6.svg";